<script>
    import { loginOneUser, forgotOneUserPassword } from '/public/services/User.js';
    import { slide } from 'svelte/transition';

    let obj = {
        email: null,
        password: null
    }
    let lerror = false;
    let showForgot = false;
    let rSuccess = false;


    function loginUser(e) {
        e.preventDefault();

        lerror = false;

        loginOneUser(obj).then(res => {
            if (res.success) {

                window.location= res.data.url;

            } else {
                lerror = true;
            }
        });
    }

    function resetPasswordForm(e) {
        e.preventDefault();

        rSuccess = false;

        forgotOneUserPassword({
            email: obj.email
        }).then(res => {
            if (res.success) {
                rSuccess = true;
            }
        });
    }

</script>
<div class='row justify-content-center mt-5 mb-5'>
    <div class='col-sm-12 col-md-6 col-lg-4'>

        {#if showForgot === false}

            <div class='card'>
                <div class='card-header'>
                    <span class='fas fa-sign-in-alt'></span> Login
                </div>
                <div class='card-body'>

                    {#if lerror === true}

                        <div class='alert alert-danger clearfix mb-3' in:slide out:slide>
                            <h4 class='float-start me-3'>
                                <span class='fas fa-info-circle'></span>
                            </h4>
                            Your email/password combination are invalid credentials for logging into this app.
                        </div>

                    {/if}

                    <form class='form' on:submit={loginUser}>
                        <div class="form-floating mb-3">
                            <input 
                                type="email" 
                                class="form-control" 
                                id="floatingInput" 
                                placeholder="name@example.com"
                                bind:value={obj.email}
                                required
                                class:is-invalid='{obj.email == null}'
                            >
                            <label for="floatingInput">Email address</label>
                        </div>
                        <div class="form-floating mb-3">
                            <input 
                                type="password" 
                                class="form-control" 
                                id="floatingPassword" 
                                placeholder="Password"
                                bind:value={obj.password}
                                class:is-invalid='{obj.password == null}'
                            >
                            <label for="floatingPassword">Password</label>
                        </div>
                        <div class='row mb-3'>
                            <div class='col-sm-12 text-center'>
                                <button type='submit' class='btn btn-outline-primary'>
                                    <span class='fas fa-sign-in-alt'></span> Login
                                </button>
                            </div>
                        </div>
                    </form>
                    <p class='text-end'>
                        <button type='button' class='btn btn-outline-secondary btn-sm' on:click={() => showForgot = true}>
                            <span class='fas fa-lock-open'></span> Forgot your Password?
                        </button>
                    </p>
                </div>
            </div>

        {:else}

            <p class='text-end'>
                <button type='button' class='btn btn-outline-secondary btn-sm' on:click={() => showForgot = false}>
                    <span class='fas fa-window-close'></span> Cancel
                </button>
            </p>

            <section in:slide>
                <div class='card mb-3'>
                    <div class='card-header'>
                        <span class='fas fa-lock-open'></span> Forgot your password
                    </div>
                    <div class='card-body'>
                        <p class='mb-3'>
                            <span class='fas fa-info-circle'></span> Enter your email address, and if we find an account that matches, we'll send a password reset link your inbox.
                        </p>

                        {#if rSuccess === true}

                            <div class='alert alert-info clearfix mb-3' in:slide>
                                <h4 class='float-start me-3'>
                                    <span class='fas fa-info-circle'></span>
                                </h4>
                                Check your inbox. If an account exists for { obj.email } we'll send a password reset link via email.<br/>
                                The reset link is only valid for one hour.
                            </div>

                        {/if}

                        <form class='form' on:submit={resetPasswordForm}>
                            <div class="form-floating mb-3">
                                <input 
                                    type="email" 
                                    class="form-control" 
                                    id="floatingInput" 
                                    placeholder="name@example.com"
                                    bind:value={obj.email}
                                    required
                                    class:is-invalid='{obj.email == null}'
                                >
                                <label for="floatingInput">Email address</label>
                            </div>
                            <div class='row mb-3'>
                                <div class='col-sm-12 text-center'>
                                    <button type='submit' class='btn btn-outline-primary'>
                                        <span class='fas fa-envelope'></span> Send Password Reset
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>

        {/if}
    </div>
</div>